/**
 * Same rules as src/sun-editor-content.scss.
 * Injected into the widget shadow root before styles.css loads. SSR detail pages do not run this
 * injector — they use the compiled stylesheet — so keep the two copies in sync.
 */
export const IG_SUN_EDITOR_CONTENT_CSS = `
.sun-editor-editable::after {
  content: "";
  display: block;
  clear: both;
}
.sun-editor-editable .se-component {
  max-width: 100%;
}
.sun-editor-editable .se-component.__se__float-center,
.sun-editor-editable .se-component:has(img[data-align="center"]),
.sun-editor-editable .se-component:has(video[data-align="center"]),
.sun-editor-editable .se-component:has(iframe[data-align="center"]) {
  float: none !important;
  display: flex !important;
  width: 100% !important;
  justify-content: center;
}
.sun-editor-editable .se-component.__se__float-left {
  float: left;
  margin-right: 4px;
}
.sun-editor-editable .se-component.__se__float-right {
  float: right;
  margin-left: 4px;
}
.sun-editor-editable .se-component > figure {
  display: block;
  max-width: 100%;
}
.sun-editor-editable .__se__float-center > figure,
.sun-editor-editable .__se__float-center figure {
  margin-left: auto !important;
  margin-right: auto !important;
}
.sun-editor-editable .__se__float-right > figure {
  margin-left: auto !important;
  margin-right: 0 !important;
}
.sun-editor-editable .__se__float-left > figure {
  margin-left: 0 !important;
  margin-right: auto !important;
}
.sun-editor-editable img[data-align="center"],
.sun-editor-editable video[data-align="center"],
.sun-editor-editable iframe[data-align="center"] {
  display: block;
  margin-left: auto !important;
  margin-right: auto !important;
}
.sun-editor-editable img[data-align="right"],
.sun-editor-editable video[data-align="right"],
.sun-editor-editable iframe[data-align="right"] {
  display: block;
  margin-left: auto !important;
  margin-right: 0 !important;
}
.sun-editor-editable img[data-align="left"],
.sun-editor-editable video[data-align="left"],
.sun-editor-editable iframe[data-align="left"] {
  display: block;
  margin-left: 0 !important;
  margin-right: auto !important;
}
.sun-editor-editable iframe { max-width: 100%; }
`;
